import { Container } from './Container'

export function SubHeroInternal({
  children,
  color,
  variant,
}: {
  children?: React.ReactNode
  color?: string
  variant?: 'default' | 'gradient' | 'custom'
}) {
  return (
    <Container variant={variant || 'custom'} color={color || '#0b2948'}>
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col space-y-11 py-16 md:py-24">{children}</div>
      </div>
    </Container>
  )
}
